import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p398261661603950592',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
